// case tab


$(".case__tab").on("click", function () {
    $(".case__tab").removeClass("active");
    $(".case__content-wrap").removeClass("active");
    var tabId = $(this).attr("data-tab");
    $(this).addClass("active");
    $("#" + tabId).addClass("active");
})


// additional faq
$('.additional-faq__content').hide();
$('.additional-faq__title:first').addClass('active').next('.additional-faq__content').show();
$('.additional-faq__title').off("click").on("click", function () {
    $('.additional-faq__title').not(this).removeClass('active').next('.additional-faq__content').slideUp();
    $(this).toggleClass('active').next('.additional-faq__content').slideToggle();
});



// faq
$('.faq__content').hide();
$('.faq__item-title:first').addClass('active').next('.faq__content').show();
$('.faq__item-title').off("click").on("click", function () {
    $('.faq__item-title').not(this).removeClass('active').next('.faq__content').slideUp();
    $(this).toggleClass('active').next('.faq__content').slideToggle();
});


// product faq
$('.product-faq__content').hide();
$('.product-faq__title:first').addClass('active').next('.product-faq__content').show();
$('.product-faq__title').off("click").on("click", function () {
    $('.product-faq__title').not(this).removeClass('active').next('.product-faq__content').slideUp();
    $(this).toggleClass('active').next('.product-faq__content').slideToggle();
});







// compare table select
$('#table-tab').change(function () {
    var selectedOption = '#' + $(this).val();
    $('.tab__item').removeClass('active');
    $('.tab__item[data-target="' + selectedOption + '"]').addClass('active');
    $('.compare-row').removeClass('active');
    $(selectedOption).addClass('active');
});







// ingradients select
$(".product-tab__select").on("change", function () {
    var selectedTarget = $(this).find('option:selected').data('target');
    $(".product-tab__item-wrap").removeClass("active");
    $(selectedTarget).addClass("active");
});





// faq tabs

// $(".faq__tab").on("click", function () {
//     // Remove "active" class from all buttons and frames
//     $(".faq__item-wrap").removeClass("active");
//     $(".faq__tab").removeClass("active");

//     // Get the data-tab attribute value
//     var tabId = $(this).attr("data-tab");

//     // Add "active" class to the clicked button and show the selected frame
//     $(this).addClass("active");
//     $("#" + tabId).addClass("active");
// });


  // tab collection
  $(".shop-range-butn").on("click", function () {
    // Toggle active class on buttons
    $(".shop-range-butn").removeClass("active");
    $(this).addClass("active");

    var coll_url = $(this).attr('data-url'); 
    
    // Fetch and update tab content
    fetch("/collections/" + coll_url)
      .then((response) => response.text())
      .then((tabData) => {
        var tab_html = $(tabData);
        var tab_items = $(".tab-collection-wrap", tab_html);
        $(".tab-collection-wrap").replaceWith(tab_items);
      });
});



// function tab_collection1(){
//     fetch("/collections/the-nutri-ice-cream®-1")
//       .then((response) => response.text())
//       .then((tabData) => {
//         var tab_html = $(tabData);
//         var tab_items = $(".tab-collection-wrap",tab_html);
//         $(".tab-collection-wrap").replaceWith(tab_items);
//       });
//   };





////////// 21-08-26 ******************************
document.querySelectorAll('.request_sample').forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector('#shopify-section-template--27677368516993__sample_request_GP7Dc8')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});

document.querySelectorAll('.secondary_btn').forEach(function (button) {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector('#shopify-section-template--27677368516993__resources_JAKFC6')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});